import React from 'react';
import './Registration.scss';
import CustomSignUp from "../../forms/CustomSignUp/CustomSignUp";
import Hero from "../../common/Hero/Hero";
import {useTranslation} from "react-i18next";

const Registration = () => {
    const {t} = useTranslation();

    return (
        <div className="Registration App page container-fluid" data-testid="Registration">
            <Hero backTo={'/login'} backToText={t("common.back.login")} title={t('registration.title')}/>
            <div className="container page-content-container">
                <CustomSignUp/>
            </div>
        </div>
    )
}

Registration.propTypes = {};

export default Registration;
